import { createTheme, ThemeOptions } from '@mui/material';
import { typography } from './typography';
import { palette } from './palette';
import { components } from './components';

const themeOptions: ThemeOptions = {
  typography,
  palette,
  spacing: 4, // base; we'll reference explicit tokens as needed
};

const baseTheme = createTheme({
  ...themeOptions,
  components: {
    ...components,
  },
  // Attach tokens for mapping utilities (not standard MUI fields)
  // This is safe under TS by augmenting Theme in our d.ts
  tokens: {
    spacing: {
      s: 12,
      m: 16,
      l: 20,
      xl: 24,
      xxl: 28,
      xxl2: 32,
      xxl3: 36,
    },
    borderRadius: {
      full: '9999px',
    },
    layout: {
      headerHeight: 72,
      filterPanelWidth: 350,
    },
  },
});

export const theme = baseTheme;
